import { ApexOptions } from 'apexcharts';

const chartOptions: ApexOptions = {
  chart: {
    id: 'revenue-column-card',
    fontFamily: 'Manrope, sans-serif',
    type: 'bar',

    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },

  grid: {
    borderColor: '#DFE6E9',
    row: {
      opacity: 0.5,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 2,
      columnWidth: '45%',
      colors: {
        backgroundBarColors: ['#0063F7', '#00F7BF'],
      },
    },
  },

  stroke: {
    show: true,
    width: 4,
    colors: ['transparent'],
  },
  xaxis: {
    axisTicks: {
      show: false,
      borderType: 'solid',
      color: '#78909C',
      height: 6,
      offsetX: 0,
      offsetY: 0,
    },

    tickPlacement: 'between',
    labels: {
      style: {
        colors: ['636E72'],
        fontSize: '14px',
      },
    },
  },
  legend: {
    horizontalAlign: 'right',
    offsetX: 40,
    position: 'top',
    markers: {
      radius: 12,
    },
  },
  yaxis: {
    labels: {
      style: {
        colors: ['636E72'],
        fontSize: '14px',
      },
      formatter: (value) => {
        return String(value);
      },
    },
  },
};

export function useAssetsPerStateOptions(
  assetsDescription: string[],
  data: number[],
): ApexOptions {
  return {
    ...chartOptions,
    ...{
      xaxis: {
        categories: assetsDescription,
      },
    },
  };
}

export function useAssetsPerBrandOptions(
  assetsDescription: string[],
  data: number[],
): ApexOptions {
  return {
    ...chartOptions,
    ...{
      xaxis: {
        categories: assetsDescription,
      },
    },
  };
}

export function useAssetsPerModelOptions(
  modelDescription: string[],
  data: number[],
): ApexOptions {
  return {
    ...chartOptions,
    ...{
      xaxis: {
        categories: modelDescription,
      },
    },
  };
}

export function useDonutGraphOptions(
  categories: string[],
  data: number[],
): ApexOptions {
  const total = data.reduce((prev, curr) => prev + curr, 0);
  return {
    series: data,
    chart: {
      id: 'earnings-donut-card',
      fontFamily: 'Manrope, sans-serif',
      type: 'donut',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    colors: ['#0063F7', '#98FFE0', '#1BE7FF', '#FFC212', '#FF0022', '#C903FF'],

    labels: categories,

    dataLabels: {
      enabled: false,
    },

    plotOptions: {
      pie: {
        donut: {
          size: '90%',
          labels: {
            show: true,
            name: {
              fontSize: '1rem',
            },
            value: {
              fontSize: '24px',
              fontWeight: 'regular',
              color: 'B2BEC3',
              formatter(val: string) {
                if (total === 0) {
                  return Number(0).toString();
                }

                const percentage = (100 * Number(val)) / total;
                return `%${Math.round(percentage)}`;
              },
            },
            total: {
              show: true,
              fontSize: '16px',
              fontWeight: 'regular',
              label: 'Top Equipamentos',
              color: '#636E72',
              formatter: () => '',
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 426,
        options: {
          legend: {
            itemMargin: {
              horizontal: 16,
              vertical: 8,
            },
          },
        },
      },
    ],

    legend: {
      itemMargin: {
        horizontal: 12,
        vertical: 24,
      },
      horizontalAlign: 'center',
      position: 'bottom',
      fontSize: '12px',
      inverseOrder: true,
      markers: {
        radius: 12,
      },
    },
  };
}
